var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDollarSign = function SvgDollarSign(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20366_2143)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0.000244141C12.5523 0.000244141 13 0.447959 13 1.00024V23.0002C13 23.5525 12.5523 24.0002 12 24.0002C11.4477 24.0002 11 23.5525 11 23.0002V1.00024C11 0.447959 11.4477 0.000244141 12 0.000244141Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.31802 5.31826C7.16193 4.47435 8.30653 4.00024 9.5 4.00024H17C17.5523 4.00024 18 4.44796 18 5.00024C18 5.55253 17.5523 6.00024 17 6.00024H9.5C8.83696 6.00024 8.20107 6.26364 7.73223 6.73248C7.26339 7.20132 7 7.8372 7 8.50024C7 9.16329 7.26339 9.79917 7.73223 10.268C8.20107 10.7369 8.83696 11.0002 9.5 11.0002H14.5C15.6935 11.0002 16.8381 11.4743 17.682 12.3183C18.5259 13.1622 19 14.3068 19 15.5002C19 16.6937 18.5259 17.8383 17.682 18.6822C16.8381 19.5261 15.6935 20.0002 14.5 20.0002H6C5.44772 20.0002 5 19.5525 5 19.0002C5 18.448 5.44772 18.0002 6 18.0002H14.5C15.163 18.0002 15.7989 17.7369 16.2678 17.268C16.7366 16.7992 17 16.1633 17 15.5002C17 14.8372 16.7366 14.2013 16.2678 13.7325C15.7989 13.2636 15.163 13.0002 14.5 13.0002H9.5C8.30653 13.0002 7.16193 12.5261 6.31802 11.6822C5.47411 10.8383 5 9.69372 5 8.50024C5 7.30677 5.47411 6.16218 6.31802 5.31826Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20366_2143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.000244141)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDollarSign);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dollar-sign.07f7af793b9d88035776a69a8a2022c0.svg";